import { HttpStatus } from '../../../enum';
import { isJarvisError } from '../../../util/typeGuard';
import { JarvisErrorCodes } from '../enum';
import { State } from '../index';

/**
 * Helper function to help determine which part of the UI
 * needs to be updated based on state changes
 * @param {State} newState - new state
 * @param {State} oldState - old state
 * @returns {Object} - object containing booleans
 */
export const getUpdateFlags = (state: State, oldState: State) => {
    const { addresses, selectedAddress, error } = state;

    const addressChanged = JSON.stringify(selectedAddress) !== JSON.stringify(oldState.selectedAddress);
    const addressListChanged = JSON.stringify(addresses) !== JSON.stringify(oldState.addresses);
    const errorChanged = JSON.stringify(error) !== JSON.stringify(oldState.error);

    return {
        inputs: addressChanged,
        select: addressListChanged,
        addressError: errorChanged,
        serviceError: errorChanged,
    };
};

/**
* Determine if error is caused by an invalid address entered by the user
* @param {unknown} error - any error thrown
* @returns {boolean} - is invalid address error
*/
export const isAddressError = (error: unknown): boolean =>
    isJarvisError(error) && error.body.errorCode === JarvisErrorCodes.invalidAddress;

/**
* Determine if error is caused by a program or an internal service error
* @param {unknown} error - any error thrown
* @returns {boolean} - is service error
*/
export const isAppError = (error: unknown): boolean => {
    const jarvisError = isJarvisError(error);

    return Boolean((error && !jarvisError) || jarvisError && error.status === HttpStatus.INTERNAL);
};
